import React from "react";
import logo from "../../assets/logoprakash-removebg-preview.png";
import logo2 from "../../assets/namelogo-removebg-preview-removebg-preview.png";
import "./Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow-lg rounded-border m-0 m-lg-3 mt-1">

      <div className="container">
        <a className="navbar-brand" href="/">
          <img src={logo} alt="Prakash Institute" height="50" className="me-2" />
          <img src={logo2} alt="Prakash Institute" height="50" className="me-2" />
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="/">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/about">About</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/courses">Courses</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/testimonial">Testimonial</a>
            </li>
            {/* <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown">
                Courses
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="/engineering">Engineering & Medical</a></li>
                <li><a className="dropdown-item" href="/commerce">Commerce & Arts</a></li>
                <li><a className="dropdown-item" href="/state-board">State Board & CBSE</a></li>
              </ul>
            </li> */}
            <li className="nav-item">
              <a className="nav-link" href="/contact">Contact</a>
            </li>
          </ul>
          <a href="/contact" className="btn btn-success fw-bold ms-3">Get Counseling</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;